import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesWhatsAppAdProducts } from "../../constants";

export const requestDeleteAdProduct = async (id: string): Promise<void> => {
  return await instance.delete(buildUrl(ApiRoutesWhatsAppAdProducts.AdProducts, id));
};
